/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2

$(function () {

  var productsSwiperInstances = [];
  var $productsSliders = $('.article-products');

  if ($productsSliders.length) {
    $productsSliders.each(function () {
      var $slider = $(this);

      var instance = new Swiper(this, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: false,
        grabCursor: true,
        speed: 300,
        resistanceRatio: 0.85,
        touchRatio: 1,
        touchAngle: 45,
        threshold: 3,
        followFinger: true,
        touchStartPreventDefault: false,
        touchMoveStopPropagation: false,
        nested: true,
        edgeSwipeDetection: true,
        edgeSwipeThreshold: 20,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.4,
          momentumVelocityRatio: 1,
          momentumBounce: false,
          sticky: false,
          minimumVelocity: 0.02
        },
        breakpoints: {
          800: {
            slidesPerView: 'auto',
            spaceBetween: 0
          }
        },
        cssMode: false,
        a11y: false,
        keyboard: { enabled: true, onlyInViewport: true },
        mousewheel: { forceToAxis: true, sensitivity: 0.5, releaseOnEdges: true },
        navigation: {
          nextEl: $slider.find('.article-products-button-next')[0],
          prevEl: $slider.find('.article-products-button-prev')[0]
        }
      });
      productsSwiperInstances.push(instance);

      $slider.find('img').each(function () {
        if (this.complete) {
          return;
        }
        $(this).on('load error', function () {
          instance.update();
        });
      });
    });
  }

  $(window).on('load', function () {
    productsSwiperInstances.forEach(function (instance) {
      instance.update();
    });
  });

  $(window).on('resize', function () {
    productsSwiperInstances.forEach(function (instance) {
      instance.update();
    });
  });

  function getTocOffset() {
    var offset = ($('.header').outerHeight() || 0) + 20;
    if (window.innerWidth < 1280) {
      offset += $('.table-of-content-mobile-title').outerHeight() || 0;
    }
    return offset;
  }

  function updateTocActiveState() {
    var scrollPosition = $(window).scrollTop() + getTocOffset();
    var $articleContent = $('.article-content');
    var currentSectionId = null;

    if (!$articleContent.length) {
      return;
    }

    var sectionTop = $articleContent.offset().top;

    if (scrollPosition <= sectionTop) {
      $('.table-of-content__item').removeClass('active');
      var firstItem = $('.table-of-content__item:nth-child(1)');
      if (firstItem.length) {
        firstItem.addClass('active');
      }
    } else {
      $('.article-content-main > div[id]').each(function () {
        var elementTop = $(this).offset().top;
        if (scrollPosition >= elementTop) {
          currentSectionId = $(this).attr('id');
        }
      });
      if (currentSectionId) {
        $('.table-of-content__item').removeClass('active');
        $('.table-of-content__link[data-link="' + currentSectionId + '"]').closest('li').addClass('active');
      }
    }
  }

var trackVisible = null;

function updateHeaderAttachedBars() {
  var $track = $('.article-progress-track');
  var $bar = $('.article-progress-bar');
  var $mobileToc = $('.table-of-content-mobile');
  var $articleContent = $('.article-content');

  var header = document.querySelector('.header');
  var headerBottom = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;

  if ($track.length) {
    $track.css('top', headerBottom + 'px');
  }

  if (!$track.length || !$bar.length || !$articleContent.length) {
    if ($mobileToc.length) {
      $mobileToc.css('top', headerBottom + 'px');
    }
    return;
  }

  var articleTop = $articleContent.offset().top;
  var articleHeight = $articleContent.outerHeight();
  var windowHeight = $(window).height();
  var scrollableHeight = articleHeight - windowHeight;
  var scrolled = $(window).scrollTop() - articleTop;

  var percent = scrollableHeight > 0 ? (scrolled / scrollableHeight) * 100 : 0;
  percent = Math.max(0, Math.min(100, percent));

  $bar.css('width', percent + '%');

  var shouldShowTrack = percent > 0;

  if (shouldShowTrack !== trackVisible) {
    trackVisible = shouldShowTrack;

    if (shouldShowTrack) {
      $track.stop(true).fadeIn(200);
      if ($mobileToc.length) {
        $mobileToc.stop(true).fadeIn(200);
      }
    } else {
      $track.stop(true).fadeOut(200);
      if ($mobileToc.length) {
        $mobileToc.stop(true).fadeOut(200);
      }
    }
  }

  if ($mobileToc.length) {
    var progressBarHeight = trackVisible ? $track.outerHeight() : 0;
    $mobileToc.css('top', (headerBottom + progressBarHeight) + 'px');
  }
}

  function updateTocBoundary() {
    var $wrap = $('.table-of-content-wrap');
    var $products = $('.article-products').last();
    var $body = $('.article-content-body');
    if (!$wrap.length || !$products.length || !$body.length) {
      return;
    }
    var bodyBottom = $body.offset().top + $body.outerHeight();
    $wrap.css('margin-bottom', Math.max(0, bodyBottom - $products.offset().top) + 'px');
  }

  updateHeaderAttachedBars();
  updateTocBoundary();

  $(window).on('load', function () {
    updateTocActiveState();
    updateHeaderAttachedBars();
    updateTocBoundary();

    var productsEl = $('.article-products').last()[0];
    if (productsEl && window.ResizeObserver) {
      new ResizeObserver(function () {
        updateTocBoundary();
      }).observe(productsEl);
    }

    var headerEl = document.querySelector('.header');
    if (headerEl && window.ResizeObserver) {
      var headerResizeObserver = new ResizeObserver(function () {
        updateHeaderAttachedBars();
      });
      headerResizeObserver.observe(headerEl);
    }

    var tocScrollTicking = false;
    $(window).on('scroll', function () {
      if (!tocScrollTicking) {
        window.requestAnimationFrame(function () {
          if (!window._tocScrolling) {
            updateTocActiveState();
          }
          updateHeaderAttachedBars();
          tocScrollTicking = false;
        });
        tocScrollTicking = true;
      }
    });

    $(window).on('resize', function () {
      updateHeaderAttachedBars();
      updateTocBoundary();
    });

    $('.table-of-content__link').on('click', function (e) {
      var headerHeight = $('.header').height();
      var mobileTocheight = $('.table-of-content-mobile-title').height();
      var activeID = $(this).attr('data-link');
      var $scrollToSection = $('.article-content-main div[id="' + activeID + '"]');

      if (!$scrollToSection.length) {
        return;
      }

      $('.table-of-content__item').removeClass('active');
      $(this).closest('li').addClass('active');

      var scrollTop = $(window).scrollTop();
      var targetTop = 0;

      if (window.innerWidth >= 1280) {
        if (scrollTop > $scrollToSection.offset().top) {
          targetTop = $scrollToSection.offset().top - headerHeight - 20;
        } else {
          targetTop = $scrollToSection.offset().top - 20;
        }
      } else {
        if (scrollTop > $scrollToSection.offset().top) {
          targetTop = $scrollToSection.offset().top - headerHeight - mobileTocheight - 40;
        } else {
          targetTop = $scrollToSection.offset().top - mobileTocheight - 40;
        }
        $('.table-of-content-mobile-title').trigger('click');
      }

      window._tocScrolling = true;
      window._tocScrollDown = targetTop > $(window).scrollTop();
      $('html, body').animate({ scrollTop: targetTop }, 300, function () {
        window._tocScrolling = false;
      });
    });

    $('.table-of-content-mobile-title').on('click', function () {
      var container = $(this).closest('.table-of-content-mobile');
      if (container.hasClass('active')) {
        container.removeClass('active');
        container.find('.table-of-content-mobile__list').slideUp(300);
      } else {
        container.addClass('active');
        container.find('.table-of-content-mobile__list').slideDown(300);
      }
    });
  });

  function changeImage(productCart, imageSrc) {
    var productImage = productCart.querySelector('#product_cart_image');
    if (!productImage) {
      return;
    }
    var currentSrc = productImage.src;
    var currentSrcset = productImage.srcset;
    var cdnIndex = currentSrc.indexOf('shop/');

    if (cdnIndex !== -1) {
      var updatedSrc = currentSrc.substring(0, cdnIndex + 5) + imageSrc;
      var updatedSrcset = currentSrcset.replace(/(shop\/)[^ ]+/g, 'shop/' + imageSrc);

      productImage.srcset = updatedSrcset;
      productImage.src = updatedSrc;
    }
  }

  var productCarts = document.querySelectorAll('.article-products__list .product_cart');
  productCarts.forEach(function (productCart) {
    productCart.querySelectorAll('input[type="radio"].variant-input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (this.checked) {
          changeImage(productCart, this.dataset.image);
        }
      });
    });

    productCart.querySelectorAll('.variant__label').forEach(function (label) {
      label.addEventListener('mouseenter', function () {
        var radioId = label.getAttribute('data-radio-id');
        var radioButton = productCart.querySelector('#' + radioId);
        if (!radioButton) {
          return;
        }
        radioButton.checked = true;

        var typeInput = [
          ...document.querySelectorAll(
            '.product_cart__variants.types .variant.color input[data-color="' + radioButton.dataset.color + '"]'
          )
        ].find(function (el) {
          return el.name !== radioButton.name;
        });
        if (typeInput) {
          typeInput.checked = true;
        }

        changeImage(productCart, radioButton.dataset.image);
      });
    });

    productCart.querySelectorAll('input[type="radio"].type-input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (this.checked) {
          var colors = productCart.querySelectorAll('.variant.color');
          colors.forEach(function (color) {
            color.style.display = input.dataset.name === color.dataset.name ? 'block' : 'none';
          });
          var checkedInput = document.querySelector(
            '.variant.color[data-name="' + input.dataset.name + '"] input[type="radio"]:checked'
          );
          if (checkedInput) {
            changeImage(productCart, checkedInput.dataset.image);
          }
        }
      });
    });

    productCart.querySelectorAll('.type__label').forEach(function (label) {
      label.addEventListener('mouseenter', function () {
        var radioId = label.getAttribute('data-radio-id');
        var radioButton = productCart.querySelector('#' + radioId);
        if (!radioButton) {
          return;
        }
        radioButton.checked = true;

        var colors = productCart.querySelectorAll('.variant.color');
        colors.forEach(function (color) {
          color.style.display = radioButton.dataset.name === color.dataset.name ? 'block' : 'none';
        });
        var checkedInput = document.querySelector(
          '.variant.color[data-name="' + radioButton.dataset.name + '"] input[type="radio"]:checked'
        );
        if (checkedInput) {
          changeImage(productCart, checkedInput.dataset.image);
        }
      });
    });

    productCart.querySelectorAll('.product_cart__image-block').forEach(function (block) {
      block.addEventListener('mouseenter', function () {
        var video = block.querySelector('.hovered-content video');
        if (video) {
          video.play();
        }
      });

      block.addEventListener('touchstart', function () {
        var video = block.querySelector('.hovered-content video');
        if (video) {
          video.play();
        }
      });

      block.addEventListener('mouseleave', function () {
        var video = block.querySelector('.hovered-content video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });

      block.addEventListener('touchend', function () {
        var video = block.querySelector('.hovered-content video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });
    });
  });
});